// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__13M2Z","author":"Table_author__1g7RS","authorImage":"Table_authorImage__2B_jH","unreadRow":"Table_unreadRow__3gOWp"};